import template from './price_point.html';
import controller from './price_point.controller';

let PricePointComponent = {
  restrict: 'E',
  // bindings: {
  //   hasACL: '='
  // },
  template,
  controller
};

export default PricePointComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/fuel_surcharges/price_point/price_point.component.js